const CORE_COLOR_SLUGS_BY_PRODUCT = {
    'lap':         ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'lap-siding':  ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'panel':       ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'panel-siding': ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'panels':      ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'shake':       ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'shakes':      ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'multi-shake': ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'multishake':  ['gray-clouds', 'iron-ore', 'pure-white', 'accessible-beige', 'gale-force'],
    'trim':        ['pure-white'],
    'soffit':      ['pure-white'],
};

const CORE_COLOR_ALIASES = {
    'grey-clouds': 'gray-clouds',
};

function normalizeColorKey(value) {
    if (!value) {
        return null;
    }

    const normalized = value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    return CORE_COLOR_ALIASES[normalized] ?? normalized;
}

export function getCoreColorSlugs(productEntrySlug) {
    return CORE_COLOR_SLUGS_BY_PRODUCT[productEntrySlug] ?? [];
}

export function groupColorsByCore(colors, coreSlugs) {
    if (!Array.isArray(colors) || colors.length === 0) {
        return { core: [], secondary: [] };
    }
    if (!Array.isArray(coreSlugs) || coreSlugs.length === 0) {
        return { core: [], secondary: colors.slice() };
    }

    const corePosition = new Map();
    coreSlugs.forEach((slug, index) => corePosition.set(normalizeColorKey(slug), index));

    const core = [];
    const secondary = [];
    for (const color of colors) {
        const colorKey = normalizeColorKey(color.slug) ?? normalizeColorKey(color.title);
        if (corePosition.has(colorKey)) {
            core.push(color);
        } else {
            secondary.push(color);
        }
    }

    core.sort((a, b) => {
        const aKey = normalizeColorKey(a.slug) ?? normalizeColorKey(a.title);
        const bKey = normalizeColorKey(b.slug) ?? normalizeColorKey(b.title);
        return corePosition.get(aKey) - corePosition.get(bKey);
    });

    return { core, secondary };
}

export function orderColorsByCore(colors, coreSlugs) {
    const groups = groupColorsByCore(colors, coreSlugs);
    return [...groups.core, ...groups.secondary];
}
